import NextImage from 'next/image';
import { FC } from 'react';

import RichText from 'molecules/RichText';

type FormTheme = 'light' | 'dark';

const getRootClass = (hasFeaturedImage: boolean, theme: FormTheme) => {
  if (hasFeaturedImage) {
    return 'basic-root--featured flex flex-col';
  }
  if (theme === 'light') {
    return 'basic-root--light flex flex-col gap-4';
  }

  return 'basic-root flex flex-col gap-4';
};

const getTextClass = (hasFeaturedImage: boolean, theme: FormTheme) => {
  if (hasFeaturedImage || theme === 'light') {
    return 'text-[#101828]';
  }

  return 'text-white';
};

const BasicForm: FC<FormProps & { theme?: FormTheme }> = ({
  id,
  successMessage,
  successfulSubmit,
  legalText,
  isLoading,
  labelHeading,
  featuredImage,
  theme = 'light',
}) => {
  const hasFeaturedImage = !!featuredImage?.file?.url;
  const rootClass = getRootClass(hasFeaturedImage, theme);
  const textClass = getTextClass(hasFeaturedImage, theme);
  const legalClass = theme === 'light' ? 'text-[13.5px] leading-[21px] text-[#101828]' : 'text-center text-gray-300';

  return (
    <div className={rootClass}>
      {hasFeaturedImage && (
        <div className="w-full">
          <NextImage
            src={featuredImage?.file?.url || ''}
            alt={featuredImage?.alt || 'Featured gift'}
            width={0}
            height={0}
            sizes="100vw"
            className="h-auto w-full"
            unoptimized
          />
        </div>
      )}

      <div className={hasFeaturedImage ? 'flex flex-col gap-4 bg-white px-8 pb-8 pt-6' : ''}>
        {isLoading && (
          <div className="flex w-full items-center justify-center">
            <div className="aspect-square w-12 animate-loading rounded-[50%] border-8 border-primary-300" />
          </div>
        )}

        {successfulSubmit && successMessage ? (
          <div className={textClass}>{successMessage}</div>
        ) : (
          <>
            {labelHeading && !isLoading && (
              <h3 className={`mb-2 font-roboto text-[20px] font-semibold leading-8 ${textClass}`}>{labelHeading}</h3>
            )}
            <form id={id} className="basic-form" />
            {legalText && !isLoading && <RichText text={legalText} className={legalClass} />}
          </>
        )}
      </div>
    </div>
  );
};

export default BasicForm;
